module.exports = __webpack_public_path__ + "img/mark.e1bbd3b9.svg";